/**
 * Juice Batch 1 — 技能槽「剛變 ready」偵測(純函式)。
 *
 * 戰鬥場景每幀算出各槽 cooldown 是否 ready(boolean[]),把上一幀與這一幀
 * 餵進 `detectJustReady`,回傳「這一幀剛從冷卻→可用」的槽位 index 陣列。
 * scene 用它觸發 glow 脈衝 + 輕「ready」音。
 *
 * 純函式、無 Phaser 依賴 — 方便單元測試。
 */

/**
 * 回傳由 false(上一幀冷卻中)轉成 true(這一幀可用)的槽位 index 陣列。
 * 只偵測 false→true 邊緣(rising edge);其餘組合(true→true / *→false /
 * false→false)不算。長度不一致時以兩陣列共同最短長度為準。
 */
export function detectJustReady(prev: boolean[], next: boolean[]): number[] {
  const n = Math.min(prev.length, next.length);
  const out: number[] = [];
  for (let i = 0; i < n; i++) {
    if (!prev[i] && next[i]) out.push(i);
  }
  return out;
}
